module.exports = __webpack_public_path__ + "static/media/lobo-kit-items-mobile.25b456c0.png";